// src/services/likeMeta.js (or js)

export function canonicalLikeMeta(collectionKey) {
  // Map UI keys/paths to real Firestore collection + model
  switch (collectionKey) {
    case "generaldiscussion":
    case "community":
    case "community_posts":     // allow aliases
      return { postCollection: "community_posts", likeModel: "array" };
    case "missions":
      return { postCollection: "missions", likeModel: "subdoc" };
    default:
      // Safe default if you truly have others:
      return { postCollection: "community_posts", likeModel: "array" };
  }
}
